import { type TOptions } from 'i18next';
import { useTranslation } from 'react-i18next';

export const useTranslate = () => {
  const { t: translate } = useTranslation();
  return (key: string, params?: TOptions | string | undefined, defaultValue?: string) => {
    const result =
      typeof params === 'string'
        ? translate(key, { defaultValue: params })
        : translate(key, params);
    if (result === key) {
      return defaultValue || key;
    }
    return result;
  };
};
